import { API_GOALS_PATH, getClient } from '../api';
import { Agent, IndividualGoal, ManagerGoal } from '../dtos';
import { serializeParams } from '../utils/serializer';

export interface GoalSimulation {
  agentId: Agent['id'],
  target: number,
}

export interface GoalSimulationParams {
  simulate?: boolean,
}

export async function createIndividualGoal(
  goalSimulation: GoalSimulation,
  params: GoalSimulationParams = { simulate: false },
): Promise<IndividualGoal> {
  const client = await getClient();
  const { data } = await client.post<IndividualGoal>(
    `${API_GOALS_PATH}/individual`,
    goalSimulation,
    {
      params: serializeParams(params),
    },
  );

  return data;
}

export async function createManagerGoal(
  goalSimulation: GoalSimulation,
  params: GoalSimulationParams = { simulate: false },
): Promise<ManagerGoal> {
  const client = await getClient();
  const { data } = await client.post<ManagerGoal>(
    `${API_GOALS_PATH}/manager`,
    goalSimulation,
    {
      params: serializeParams(params),
    },
  );

  return data;
}

export async function getIndividualGoalByAgentId(agentId: number): Promise<IndividualGoal> {
  const client = await getClient();
  const { data } = await client.get(`${API_GOALS_PATH}/individual/${agentId}`);

  return data;
}

export async function getManagerGoalByAgentId(agentId: number): Promise<ManagerGoal> {
  const client = await getClient();
  const { data } = await client.get(`${API_GOALS_PATH}/manager/${agentId}`);

  return data;
}
